import {ParametreDto, servicesApi} from "@common/services";

const PARAMETRE_URL_PREFIX = 'parametre';

const parametreApi = servicesApi.injectEndpoints!({
    endpoints: (build) => ({

        getParametre: build.query<ParametreDto, void, any>({
            query: () => ({
                url: PARAMETRE_URL_PREFIX,
            }),
            providesTags: ['Parametre'],
        }),

        updateParametre: build.mutation<void, UpdateParametreArgs, any>({
            query: ({ id, dto }) => ({
                url: `${PARAMETRE_URL_PREFIX}/${id}`,
                method: 'PATCH',
                body: dto,
            }),
            invalidatesTags: ['Parametre'],
        }),

    }),
});

export interface UpdateParametreArgs {
    id: number;
    dto: Partial<ParametreDto>;
}

export const {
    useGetParametreQuery,
    useUpdateParametreMutation,
} = parametreApi;